import type { QueryClient } from '@tanstack/react-query'

import { PATIENT_HOME } from 'settings/_reactQueryConstants'

export function invalidatePatientReservationCardCache(queryClient: QueryClient): void {
  void queryClient.invalidateQueries({ queryKey: [PATIENT_HOME.RESERVATION_CARD] })
}
